import { render, staticRenderFns } from "./StudyPlanSyllabusesListModal.vue?vue&type=template&id=6d7a3f52&"
import script from "./StudyPlanSyllabusesListModal.vue?vue&type=script&lang=js&"
export * from "./StudyPlanSyllabusesListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports